import React, { Component } from "react";
import { Link } from "react-router-dom";

export class LeadsSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
        orderBy: "updatedAt",
        orderDirection: "DESC",
        page: 1,
      },
    };
    this.fields = [
      {
        name: "name",
        label: "Name",
        type: "text",
        placeholder: "Name",
      },
      {
        name: "mobile_no",
        label: "Mobile No",
        type: "number",
        placeholder: "Mobile No",
      },
      {
        name: "requirement",
        label: "Requirement",
        type: "select",
        options: _enum.SALES_REQUIREMENTS,
        placeholder: "Requirement",
      },
      {
        name: "status",
        label: "Status",
        type: "select",
        options: _enum.SALES_ENQUIRY_STATUS,
        placeholder: "Status",
      },
    ];
  }

  componentDidMount() {}

  // getProductTypes() {
  //   this.props.apis.apiGetProductTypes().then((res) => {
  //     let productType = this.fields.find((o) => o.name == "productType");
  //     productType.options = res.options("productType");
  //   });
  // }

  onSearch = (reset = false) => {
    let data = this.refs.form.form.current.getData();
    console.log("onSearch formData", data, reset);
    if (reset) {
      data = {
        ...this.state.search,
      };
    } else {
      data = Object.filter(data, (val) => val);
      // console.log("data on search", data);
    }
    this.props.onSearch && this.props.onSearch(data, reset);
    // this.refs.form.form.current.reset();
  };

  resetSearchForm() {
    this.refs.form.form.current.reset();
    this.onSearch(true);
  }

  render() {
    return (
      <>
        <AppForm
          className="row filter-row flex-auto mx-auto position-relative leads_search"
          ref="form"
        >
          {this.fields.map((field, i) => (
            <div
              className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 input_column"
              key={i}
            >
              <AppInputFocus ref="inputname" {...field}></AppInputFocus>
            </div>
          ))}
          <div className="col-6 col-md-1 col-lg-1 col-xl-1 d-flex align-items-start justify-content-center mw-lg-75">
            <button
              className="btn btn-primary search_btn"
              onClick={() => this.onSearch()}
            >
              <i className="fa fa-search"></i>
              <span>Search</span>
            </button>
          </div>
          <div className="col-6 col-md-1 col-lg-1 col-xl-1 mw-lg-75">
            <button
              type="button"
              className="btn btn-primary clear_filter_btn mb-3"
              onClick={(...args) => this.resetSearchForm(...args)}
            >
              <i class="fa-solid fa-filter-circle-xmark"></i>
            </button>
          </div>
        </AppForm>
      </>
    );
  }
}

export default constore(LeadsSearch);
